import { noop } from 'lodash-es';
export const makePasswordPolicyLoader = (importPolicy)=>{
    const cache = {
        policy: null
    };
    const load = ()=>{
        if (cache.policy == null) {
            cache.policy = importPolicy().catch((error)=>{
                cache.policy = null;
                throw error;
            });
        }
        return cache.policy;
    };
    return {
        warm: ()=>load().then(noop, noop),
        score: (password, userInputs)=>load().then((policy)=>policy.getPasswordScore(password, userInputs), ()=>null),
        validate: async (password, userInputs)=>(await load()).validatePasswordStrength(password, userInputs)
    };
};
const passwordPolicyLoader = makePasswordPolicyLoader(()=>import('anchor-password-policy'));
export const warmPasswordPolicy = ()=>passwordPolicyLoader.warm();
export const getPasswordScoreAsync = (password, userInputs)=>passwordPolicyLoader.score(password, userInputs);
export const validatePasswordStrengthAsync = (password, userInputs)=>passwordPolicyLoader.validate(password, userInputs);
